
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M54 0H6C2.7 0 .03 2.7.03 6L0 60l12-12h42c3.3 0 6-2.7 6-6V6c0-3.3-2.7-6-6-6zM15 21h30c1.65 0 3 1.35 3 3s-1.35 3-3 3H15c-1.65 0-3-1.35-3-3s1.35-3 3-3zm18 15H15c-1.65 0-3-1.35-3-3s1.35-3 3-3h18c1.65 0 3 1.35 3 3s-1.35 3-3 3zm12-18H15c-1.65 0-3-1.35-3-3s1.35-3 3-3h30c1.65 0 3 1.35 3 3s-1.35 3-3 3z","fill":"#e5e5ec","fill-rule":"nonzero"}})])
          )
        }
      }
    